import type { RouteRecordRaw } from 'vue-router'

import { organizationDetailLayoutMeta } from './shared'

const routeOtherDetail: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/relations/OrganizationDetailView.vue')
  },
  name: 'other-detail',
  path: '',
}

const routeOtherFileOverview: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/file/SubmenuFiles.vue')
  },
  name: 'other-file-overview',
  path: 'file-overview',
}

const routeOtherInformation: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/other/SubmenuInformation.vue')
  },
  name: 'other-information',
  path: 'other-information',
}

const routeOtherRoot: RouteRecordRaw = {
  children: [routeOtherDetail, routeOtherFileOverview, routeOtherInformation],
  component: async () => {
    return await import('@/components/relationships/organizations/OrganizationDetailBase.vue')
  },
  meta: organizationDetailLayoutMeta,
  path: 'others/:id',
}

export { routeOtherDetail, routeOtherFileOverview, routeOtherInformation, routeOtherRoot }
